"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Tag = require("./Tag.styles");

var _icons = require("../../assets/icons");

var _elements = require("../../styles/elements");

var Tag = function Tag(_ref) {
  var children = _ref.children,
      closable = _ref.closable,
      size = _ref.size,
      type = _ref.type,
      error = _ref.error,
      onClose = _ref.onClose,
      className = _ref.className;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      off = _useState2[0],
      setOff = _useState2[1];

  var handleClick = (0, _react.useCallback)(function (e) {
    e.stopPropagation();
    setOff(true);

    if (typeof onClose === 'function') {
      onClose();
    }
  }, [setOff, onClose]);

  if (off) {
    return null;
  }

  return (0, _jsxRuntime.jsxs)("div", {
    css: [_Tag.styles[type], _Tag.styles[size], error && _Tag.styles.error, process.env.NODE_ENV === "production" ? "" : ";label:Tag;"],
    className: className,
    children: [children, closable && (0, _jsxRuntime.jsx)("button", {
      className: "grui",
      css: _elements.button.styles.preflight,
      type: "button",
      onClick: handleClick,
      children: (0, _jsxRuntime.jsx)(_icons.Close, {})
    })]
  });
};

Tag.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  closable: _propTypes.bool,
  size: (0, _propTypes.oneOf)(['big', 'small']),
  type: (0, _propTypes.oneOf)(['normal', 'email']),
  className: _propTypes.string,
  error: _propTypes.bool,
  // Handle click close button
  onClose: _propTypes.func
};
Tag.defaultProps = {
  children: undefined,
  closable: false,
  size: 'big',
  type: 'normal',
  className: undefined,
  error: undefined,
  onClose: undefined
};
var _default = Tag;
exports["default"] = _default;
//# sourceMappingURL=Tag.js.map